// Tanner Fry
// tannerf1101@yahoo.com
// API calls for user preferences.

import { ColorResult } from "react-color";
import { fetchAPIPOSTByUserUuid } from "./Common";

// User Preferences
export interface IUserPreferences {
    appThemeColor: string,
    menuThemeColor: string,
    idleTimeoutEnabled: boolean,
    maintenanceTooltipEnabled: boolean,
    notificationPopupEnabled: boolean,
    dashboardPrimaryColor: string,
    dashboardSecondaryColor: string
}
export interface IUserPreferencesResponse {
    data: {
        appThemeColor: string,
        menuThemeColor: string,
        idleTimeoutEnabled: boolean,
        maintenanceTooltipEnabled: boolean,
        notificationPopupEnabled: boolean,
        dashboardPrimaryColor: string,
        dashboardSecondaryColor: string
    },
    error: string
}
export interface IReturnPropsUpdateUserPreferencesComplete {
    response: {
        userPreferences?: IUserPreferences
        error?: string
        dataReceived?: IUserPreferences
    },

}

// export const APIGetUserPreferences = () => {

//     return fetchAPIGET('/api/users/preferences');
// }
export const APIGetUserPreferencesByUserUuid = () => {

    return fetchAPIPOSTByUserUuid<IUserPreferencesResponse>('/api/users/preferences', {});
}
export const APIPOSTUserPreferences = () => {

    return fetchAPIPOSTByUserUuid<IUserPreferences>('/api/users/preferences/add', {});
}
export const APIPOSTUPDATEUserPreferencesIdleTimeout = (toggleChecked: boolean) => {
    let toggleCheckedNumber: number = 0;
    if (toggleChecked) {
        toggleCheckedNumber = 1;
    } else {
        toggleCheckedNumber = 0;
    }
    console.log("Toggle checked number: ", toggleCheckedNumber);

    return fetchAPIPOSTByUserUuid<IUserPreferences>('/api/users/preferences/update', {
        idleTimeoutEnabled: toggleCheckedNumber
    });
}
export const APIPOSTUPDATEUserPreferencesMenuThemeColor = (color: ColorResult) => {

    return fetchAPIPOSTByUserUuid<IUserPreferences>('/api/users/preferences/update', {
        menuThemeColor: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
    });
}
export const APIPOSTUPDATEUserPreferencesMaintenanceTooltip = (toggleChecked: boolean) => {
    let toggleCheckedNumber: number = 0;
    if (toggleChecked) {
        toggleCheckedNumber = 1;
    } else {
        toggleCheckedNumber = 0;
    }
    console.log("Toggle checked number: ", toggleCheckedNumber);

    return fetchAPIPOSTByUserUuid<IUserPreferences>('/api/users/preferences/update', {
        maintenanceTooltipEnabled: toggleCheckedNumber
    });
}
export const APIPOSTUPDATEUserPreferencesNotificationPopup = (toggleChecked: boolean) => {
    let toggleCheckedNumber: number = 0;
    if (toggleChecked) {
        toggleCheckedNumber = 1;
    } else {
        toggleCheckedNumber = 0;
    }
    console.log("Toggle checked number: ", toggleCheckedNumber);

    return fetchAPIPOSTByUserUuid<IUserPreferences>('/api/users/preferences/update', {
        notificationPopupEnabled: toggleCheckedNumber
    });
}
export const APIPOSTUPDATEUserPreferencesComplete = (userPreferences: IUserPreferences) => {
    console.log("Updating user preferences to: ", userPreferences);
    
    return fetchAPIPOSTByUserUuid<IReturnPropsUpdateUserPreferencesComplete>('/api/users/preferences/update', {
        appThemeColor: userPreferences.appThemeColor,
        menuThemeColor: userPreferences.menuThemeColor,
        dashboardPrimaryColor: userPreferences.dashboardPrimaryColor,
        dashboardSecondaryColor: userPreferences.dashboardSecondaryColor,
        maintenanceTooltipEnabled: userPreferences.maintenanceTooltipEnabled,
        notificationPopupEnabled: userPreferences.notificationPopupEnabled,
        idleTimeoutEnabled: userPreferences.idleTimeoutEnabled,
    });
}